export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'التطبيق',
            'news': 'أخبار',
            'horizontal': 'أفقي',
            'horizontalMenu': 'القائمة الأفقية',
            'general': 'جنرال لواء',
            'component': 'مكون',
            'features': 'الميزات',
            'applications': 'تطبيقات',
            'dashboard': 'لوحة القيادة',
            'dashboard1': 'لوحة البيانات 1',
            'dashboard2': 'لوحة القيادة 2',
            'dashboard3': 'لوحة القيادة 3',
            'modules': 'وحدات',
            'agency': 'وكالة',
            'pages': 'صفحات',
            'gallery': 'صالة عرض',
            'pricing': 'التسعير',
            'terms&Conditions': 'البنود و الظروف',
            'feedback': 'ردود الفعل',
            'report': 'أبلغ عن',
            'faq(s)': 'أسئلة وأجوبة (ق)',
            'advancedComponent': 'مكون متقدم',
            'blank': 'فراغ',
            'session': 'جلسة',
            'login': 'تسجيل الدخول',
            'register': 'تسجيل',
            'lockScreen': 'اقفل الشاشة',
            'forgotPassword': 'هل نسيت كلمة المرور',
            'uiComponents': 'مكونات واجهة المستخدم',
            'alerts': 'التنبيهات',
            'appBar': 'شريط التطبيق',
            'avatars': 'الآلهة',
            'buttons': 'وصفت',
            'bottomNavigations': 'التنقلات السفلية',
            'badges': 'شارات',
            'cards': 'بطاقات',
            'cardsMasonry': 'بطاقات البناء',
            'chip': 'رقاقة',
            'dialog': 'الحوار',
            'dividers': 'فواصل',
            'drawers': 'أدراج',
            'popover': 'البوب',
            'expansionPanel': 'لوحة التوسعة',
            'gridList': 'قائمة الشبكة',
            'list': 'قائمة',
            'menu': 'قائمة طعام',
            'popoverAndToolTip': 'تلميحالبوب',
            'progress': 'تقدم',
            'snackbar': 'مطعم الوجبات الخفيفة',
            'selectionControls': 'ضوابط الاختيار',
            'advanceUiComponents': 'مكونات واجهة المستخدم المتقدمة',
            'dateAndTimePicker': 'التاريخ والوقت المنتقى',
            'tabs': 'علامات التبويب',
            'stepper': 'السائر',
            'notification': 'إعلام',
            'sweetAlert': 'الحلو تنبيه',
            'autoComplete': 'إكمال تلقائي',
            'aboutUs': 'معلومات عنا',
            'widgets': 'الحاجيات',
            'forms': 'إستمارات',
            'formElements': 'عناصر النموذج',
            'textField': 'حقل النص',
            'selectList': 'اختر القائمة',
            'charts': 'الرسوم البيانية',
            'reCharts': 'إعادة الرسوم البيانية',
            'reactChartjs2': 'تتفاعل خريطة شبيبة 2',
            'icons': 'الرموز',
            'themifyIcons': 'معهمإذاذ الأيقونات',
            'simpleLineIcons': 'أيقونات الخط البسيط',
            'fontAwesome': 'خط رائع',
            'materialIcons': 'أيقونات المواد',
            'tables': 'الجداول',
            'basic': 'الأساسية',
            'dataTable': 'جدول البيانات',
            'responsive': 'متجاوب',
            'reactTable': 'رد فعل الجدول',
            'maps': 'خرائط',
            'googleMaps': 'خرائط جوجل',
            'leafletMaps': 'خرائط النشرة',
            'inbox': 'صندوق الوارد',
            'users': 'المستخدمين',
            'userProfile1': 'ملف تعريف المستخدم 1',
            'userProfile2': 'ملف تعريف المستخدم 2',
            'userManagement': 'إدارةالمستخدم',
            'userProfile': 'ملف تعريفي للمستخدم',
            'userList': 'قائمة المستخدم',
            'calendar': 'التقويم',
            'cultures': 'الثقافات',
            'dnd': 'دالثانية',
            'selectable': 'اختيار',
            'customRendering': 'التقديم المخصص',
            'chat': 'دردشة',
            'toDo': 'لكى يفعل',
            'editor': 'محرر',
            'wysiwygEditor': 'محرر WYSIWYG',
            'quillEditor': 'محرر ريشة',
            'reactAce': 'رد فعل ايس',
            'dragAndDrop': 'اسحب وإسقاط',
            'reactDragula': 'رد دراغولا',
            'reactDnd': 'رد دالثانية',
            'blogManagement': 'إدارة المدونات',
            'ecommerce': 'التجارة الإلكترونية',
            'shopList': 'قائمة متجر',
            'shopGrid': 'متجر الشبكة',
            'invoice': 'فاتورة',
            'multilevel': 'متعدد المستويات',
            'sublevel': 'متعدد المستويات',
            'dateTimePicker': 'التاريخ والوقت المنتقى',
            'user': 'المستخدم',
            'miscellaneous': 'متنوع',
            'promo': 'الترويجي',
            'gettingStarted': 'ابدء',
            'shop': 'متجر',
            'cart': 'عربة التسوق',
            'checkout': 'الدفع',
            'saas': 'أمانة الشؤون الإدارية',
            'multiLevel': 'متعدد المستويات',
            'level1': 'المستوى 1',
            'level2': 'المستوي 2',
            'boxed': 'محاصر',
            'extensions': 'ملحقات',
            'imageCropper': 'صورة كروبر',
            'videoPlayer': 'مشغل فديوهات',
            'dropzone': 'Dropzone',
            'crm': 'CRM',
            'projects': 'مشاريع',
            'projectDetail': 'تفاصيل المشروع',
            'clients': 'عملاء',
            'reports': 'تقارير'
        },
        'widgets': {
            'totalEarns': 'مجموع يكسب',
            'emailsStatistics': 'إحصائيات البريد الإلكتروني',
            'totalRevenue': 'إجمالي الإيرادات',
            'onlineVistors': 'زوار الانترنت',
            'trafficSources': 'مصادر حركة المرور',
            'RecentOrders': 'الطلبيات الأخيرة',
            'topSellings': 'أعلى بيع',
            'productReports': 'تقارير المنتجات',
            'productStats': 'إحصائيات المنتج',
            'ComposeEmail': 'إنشاء البريد الإلكتروني',
            'employeePayroll': 'موظف الرواتب',
            'visitors': 'الزائرين',
            'orders': 'أوامر',
            'orderStatus': 'حالة الطلب',
            'totalSales': 'إجمالي المبيعات',
            'netProfit': 'صافي الربح',
            'overallTrafficStatus': 'الحالة العامة لحركة المرور',
            'tax': 'ضريبة',
            'expenses': 'نفقات',
            'currentTime': 'الوقت الحالي',
            'currentDate': 'التاريخ الحالي',
            'todayOrders': 'أوامر اليوم',
            'toDoList': 'للقيام قوائم',
            'discoverPeople': 'اكتشف الناس',
            'commments': 'تعليقات',
            'newCustomers': 'زبائن الجدد',
            'recentNotifications': 'اشعارات حديثة',
            'appNotifications': 'اشعارات التطبيق',
            'newEmails': 'رسائل البريد الإلكتروني الجديدة',
            'siteVisitors': 'زوار الموقع',
            'socialCompanines': 'الشركات الاجتماعية',
            'recentActivities': 'أنشطة حالية',
            'recentOrders': 'الطلبيات الأخيرة',
            'ratings': 'تصنيفات',
            'gallery': 'صالة عرض',
            'pricing': 'التسعير',
            'enterpriseEdition': 'الطبعة المؤسسة',
            'personalEdition': 'الطبعة الشخصية',
            'teamEdition': 'إصدار الفريق',
            'standard': 'اساسي',
            'advanced': 'المتقدمة',
            'master': 'رئيس',
            'Mega': 'ميجا',
            'logIn': 'تسجيل الدخول',
            'signUp': 'سجل',
            'lockScreen': 'اقفل الشاشة',
            'alertsWithLink': 'تنبيهات مع وصلة',
            'additionalContent': 'محتوى إضافي',
            'alertDismiss': 'تنبيه رفض',
            'uncontrolledDisableAlerts': 'غير المنضبط تعطيل التنبيهات',
            'contexualAlerts': 'التنبيهات قريني',
            'alertsWithIcons': 'التنبيهات مع الأيقونات',
            'Simple App Bars': 'أشرطة التطبيق بسيطة',
            'appBarsWithButtons': 'أشرطة التطبيق مع أزرار',
            'imageAvatars': 'الصورة الرمزية',
            'lettersAvatars': 'رسائل الآلهة',
            'iconsAvatars': 'أيقونات الصور الرمزية',
            'flatButtons': 'أزرار مسطحة',
            'raisedButton': 'زر أثار',
            'buttonWithIconAndLabel': 'زر مع أيقونة وعلامة',
            'floatingActionButtons': 'أزرار العمل العائمة',
            'iconButton': 'أيقونة زر',
            'socialMediaButton': 'زر وسائل الاعلام الاجتماعية',
            'reactButton': 'رد فعل زر',
            'buttonOutline': 'مخطط الزر',
            'buttonSize': 'حجم الزر',
            'buttonState': 'حالة الزر',
            'buttonNavigationWithNoLabel': 'زر التنقل بدون تسمية',
            'buttonNavigation': 'زر الملاحة',
            'iconNavigation': 'رمز الملاحة',
            'badgeWithHeadings': 'شارة مع عناوين',
            'contexualVariations': 'الاختلافات السياقية',
            'badgeLinks': 'روابط الشارات',
            'materialBadge': 'شارة المواد',
            'simpleCards': 'بطاقات بسيطة',
            'backgroundVarient': 'متغير الخلفية',
            'cardOutline': 'مخطط البطاقة',
            'overlayCard': 'مخطط البطاقة',
            'cardGroup': 'مجموعة البطاقات',
            'cardTitle': 'عنوان البطاقة',
            'speacialTitleTreatment': 'عنوان خاص العلاج',
            'chipWithClickEvent': 'رقاقة مع حدث الصحافة',
            'chipArray': 'رقاقة المصفوفة',
            'dialogs': 'الحوارات',
            'listDividers': 'قائمة المقسمات',
            'insetDividers': 'الفواصل الداخلية',
            'temporaryDrawers': 'أدراج مؤقتة',
            'permanentDrawers': 'أدراج دائمة',
            'simpleExpansionPanel': 'لوحة توسيع بسيطة',
            'controlledAccordion': 'الأكورديون تحت السيطرة',
            'secondaryHeadingAndColumns': 'العنوان الثانوي والأعمدة',
            'imageOnlyGridLists': 'صورة قوائم الشبكة فقط',
            'advancedGridLists': 'قوائم الشبكة المتقدمة',
            'singleLineGridLists': 'قوائم شبكة خط واحد',
            'simpleLists': 'قوائم بسيطة',
            'folderLists': 'قوائم المجلدات',
            'listItemWithImage': 'عنصر القائمة مع صورة',
            'switchLists': 'قوائم التبديل',
            'insetLists': 'القوائم الداخلية',
            'nestedLists': 'القوائم المتداخلة',
            'checkboxListControl': 'التحكم في قائمة خانة الاختيار',
            'pinedSubHeader': 'رأس فرعي موهون',
            'InteractiveLists': 'القوائم التفاعلية',
            'simpleMenus': 'القوائم البسيطة',
            'selectedMenu': 'القائمة المختارة',
            'maxHeightMenu': 'ماكس الطول القائمة',
            'changeTransition': 'تغيير التحول',
            'paper': 'ورقة',
            'anchorPlayGround': 'انكور بلاى جراوند',
            'tooltip': 'تلميح',
            'positionedToolTips': 'وضعه سناكبار',
            'circularProgressBottomStart': 'التعميم التقدم القاع البدء',
            'interactiveIntegration': 'التكامل التفاعلي',
            'determinate': 'حاسم',
            'linearProgressLineBar': 'خط خط تقدم خطي',
            'indeterminate': 'غير محدد',
            'buffer': 'متعادل',
            'query': 'سؤال',
            'transitionControlDirection': 'اتجاه التحكم في الانتقال',
            'simpleSnackbar': 'بسيط مطعم الوجبات الخفيفة',
            'positionedSnackbar': 'وضعه سناكبار',
            'contexualColoredSnackbars': 'قريني ملون وجبة خفيفة الحانات',
            'simpleCheckbox': 'خانة اختيار بسيطة',
            'interminateSelection': 'انتقاء العدائية',
            'disabledCheckbox': 'مربع اختيار معطل',
            'customColorCheckbox': 'خانة اختيار لون مخصص',
            'VerticalStyleCheckbox': 'خانة اختيار نمط عمودي',
            'horizontalStyleCheckbox': 'خانة اختيار نمط أفقي',
            'radioButtons': 'أزرار الراديو',
            'disabledRadio': 'راديو معطل',
            'withError': 'مع خطأ',
            'switches': 'و swiches',
            'dateAndTimePicker': 'التاريخ والوقت المنتقى',
            'defaultPicker': 'الافتراضي المنتقى',
            'timePicker': 'منتقي الوقت',
            'weekPicker': 'أسبوع المنتقى',
            'defaultDatePicker': 'منتقي التاريخ الافتراضي',
            'customPicker': 'العرف المنتقى',
            'tabs': 'علامات التبويب',
            'fixedTabs': 'علامات ثابتة',
            'basicTab': 'علامة تبويب أساسية',
            'wrappedLabels': 'تسميات ملفوفة',
            'centeredLabels': 'تسميات مركزية',
            'forcedScrolledButtons': 'أزرار التمرير القسري',
            'iconsTabs': 'الأيقونات علامات التبويب',
            'withDisableTabs': 'مع تعطيل علامات التبويب',
            'iconWithLabel': 'أيقونة مع تسمية',
            'stepper': 'السائر',
            'horizontalLinear': 'أفقي خطي',
            'horizontalNonLinear': 'أفقي غير خطي',
            'horizontalLinerAlternativeLabel': 'بطانة أفقية بديلة التسمية',
            'horizontalNonLinerAlternativeLabel': 'العلامة الأفقية غير اللا Liner Alternative Label',
            'verticalStepper': 'السائر الرأسي',
            'descriptionAlert': 'وصف تنبيه',
            'customIconAlert': 'أيقونة مخصص التنبيه',
            'withHtmlAlert': 'مع تنبيه Html',
            'promptAlert': 'تنبيه عاجل',
            'passwordPromptAlert': 'تنبيه تنبيه كلمة المرور',
            'customStyleAlert': 'تنبيه مخصص ستايل',
            'autoComplete': 'إكمال تلقائي',
            'reactSelect': 'رد الفعل اختر',
            'downshiftAutoComplete': 'Downshift السيارات كاملة',
            'reactAutoSuggests': 'رد فعل السيارات يقترح',
            'aboutUs': 'معلومات عنا',
            'ourVission': 'رؤيتنا',
            'ourMissions': 'مهماتنا',
            'ourMotivation': 'الدافع لدينا',
            'defualtReactForm': 'نموذج رد الفعل الافتراضي',
            'url': 'رابط',
            'textArea': 'منطقة النص',
            'file': 'ملف',
            'formGrid': 'شبكة النموذج',
            'inlineForm': 'نموذج مضمن',
            'inputSizing': 'حجم المدخلات',
            'inputGridSizing': 'حجم الشبكة المدخلة',
            'hiddenLabels': 'التسميات الخفية',
            'formValidation': 'التحقق من صحة النموذج',
            'number': 'رقم',
            'date': 'تاريخ',
            'time': 'زمن',
            'color': 'اللون',
            'search': 'بحث',
            'selectMultiple': 'اختر متعددة',
            'inputWithSuccess': 'مدخلات مع النجاح',
            'inputWithDanger': 'المدخلات مع الخطر',
            'simpleTextField': 'المدخلات مع الخطر...',
            'componet': 'المكونات',
            'layouts': 'تخطيطات',
            'inputAdorements': 'ادور المدخلات',
            'formattedInputs': 'المدخلات المنسقة',
            'simpleSelect': 'اختيار بسيط',
            'nativeSelect': 'اختيار الأصلي',
            'MutltiSelectList': 'قائمة تحديد متعددة',
            'lineChart': 'خط الرسم البياني',
            'barChart': 'شريط الرسم البياني',
            'stackedBarChart': 'مخطط شريط مكدس',
            'lineBarAreaChart': 'خط منطقة الرسم البياني',
            'areaChart': 'مخطط المساحة',
            'stackedAreaChart': 'مخطط مساحي مكدس',
            'verticalChart': 'مخطط عمودي',
            'radarChart': 'مخطط الرادار',
            'doughnut': 'تبرع',
            'polarChart': 'الخريطة القطبية',
            'pieChart': 'مخطط دائري',
            'bubbleChart': 'مخطط فقاعة',
            'horizontalBar': 'عارضة أفقية',
            'basicTable': 'الجدول الأساسي',
            'contexualColoredTable': 'قريني ملون الطاولة',
            'dataTable': 'جدول البيانات',
            'employeeList': 'قائمة موظف',
            'responsiveTable': 'الجدول المستجيب',
            'responsiveFlipTable': 'استجابة فليب الجدول',
            'reactGridControlledStateMode': 'استجابة فليب الجدول...',
            'googleMaps': 'خرائط جوجل',
            'productsReports': 'تقارير المنتجات',
            'taskList': 'قائمة المهام',
            'basicCalender': 'التقويم الأساسي',
            'culturesCalender': 'التقويم الثقافات',
            'dragAndDropCalender': 'سحب وإسقاط التقويم',
            'selectableCalender': 'اختيار التقويم',
            'customRendering': 'التقديم المخصص',
            'customCalender': 'التقويم المخصص',
            'searchMailList': 'البحث في قائمة البريد',
            'forgetPassword': 'نسيت كلمة المرور',
            'QuickLinks': 'روابط سريعة',
            'upgradeToPro': 'تطوير',
            'upgrade': 'تطوير',
            'app': 'التطبيق',
            'addNew': 'اضف جديد',
            'orderDate': 'تاريخ الطلب',
            'status': 'الحالة',
            'trackingNumber': 'أرقام التتبع',
            'action': 'عمل',
            'designation': 'تعيين',
            'subject': 'موضوع',
            'send': 'إرسال',
            'saveAsDrafts': 'حفظ كمسودات',
            'onlineSources': 'المصادر عبر الإنترنت',
            'lastMonth': 'الشهر الماضي',
            'widgets': 'الحاجيات',
            'listing': 'قائمة',
            'paid': 'دفع',
            'refunded': 'ردها',
            'done': 'فعله',
            'pending': 'قيد الانتظار',
            'cancelled': 'ألغيت',
            'approve': 'يوافق',
            'following': 'التالية',
            'follow': 'إتبع',
            'graphs&Charts': 'الرسوم البيانية والرسوم البيانية',
            'open': 'افتح',
            'bounced': 'وثب',
            'spam': 'بريد مؤذي',
            'unset': 'غير مصلد',
            'bandwidthUse': 'استخدام النطاق الترددي',
            'dataUse': 'استخدام البيانات',
            'unsubscribe': 'إلغاء الاشتراك',
            'profile': 'الملف الشخصي',
            'messages': 'رسائل',
            'support': 'الدعم',
            'faq(s)': 'أسئلة وأجوبة (ق)',
            'upgradePlains': 'ترقية السهول',
            'logOut': 'الخروج',
            'mail': 'بريد',
            'adminTheme': 'موضوع المسؤول',
            'wordpressTheme': 'وورد الموضوع',
            'addToCart': 'أضف إلى السلة',
            'plan': 'خطة',
            'basic': 'الأساسية',
            'pro': 'طليعة',
            'startToBasic': 'البدء في الأساسي',
            'upgradeToAdvance': 'الترقية إلى الأمام',
            'comparePlans': 'قارن الخطط',
            'free': 'حر',
            'frequentlyAskedQuestions': 'أسئلة مكررة',
            'searchIdeas': 'البحث عن الأفكار',
            'startDate': 'تاريخ البدء',
            'endDate': 'تاريخ الانتهاء',
            'category': 'الفئة',
            'apply': 'تطبيق',
            'downloadPdfReport': 'تنزيل تقرير Pdf',
            'yesterday': 'في الامس',
            'totalOrders': 'مجموع الطلبيات',
            'totalVisitors': 'مجموع الزوار',
            'typeYourQuestions': 'اكتب أسئلتك',
            'username': 'اسم المستخدم',
            'password': 'كلمه السر',
            'signIn': 'تسجيل الدخول',
            'enterYourPassword': 'ادخل رقمك السري',
            'alreadyHavingAccountLogin': 'بالفعل لديك حساب تسجيل الدخول',
            'composeMail': 'كتابة رسالة',
            'issue': 'القضية',
            'recentChat': 'الدردشة الأخيرة',
            'previousChat': 'الدردشة السابقة',
            'all': 'الكل',
            'filters': 'مرشحات',
            'deleted': 'تم الحذف',
            'starred': 'تألق',
            'frontend': 'نهاية المقدمة',
            'backend': 'الخلفية',
            'api': 'المعهد',
            'simpleAppBar': 'شريط التطبيقات بسيط',
            'recents': 'حديثي',
            'cardLink': 'رابط البطاقة',
            'anotherLink': 'رابط آخر',
            'cardSubtitle': 'عنوان فرعي للبطاقة',
            'confirmationDialogs': 'حوارات التأكيد',
            'deletableChip': 'رقاقة محذوفة',
            'customDeleteIconChip': 'مخصص حذف رمز رقاقة',
            'openAlertDialog': 'فتح حوار التنبيه',
            'openResponsiveDialog': 'افتح مربع حوار متجاوب',
            'openSimpleDialog': 'افتح مربع حوار بسيط',
            'openFormDialog': 'افتح مربع حوار النموذج',
            'follower': 'تابع',
            'important': 'مهم',
            'private': 'نشر',
            'openLeft': 'افتح اليسار',
            'openRight': 'افتح الحق',
            'openTop': 'مكشوفة',
            'openBottom': 'فتح القاع',
            'selectTripDestination': 'اختر وجهة الرحلة',
            'pinnedSubHeaderList': 'مثبت رأس القائمة الفرعية',
            'singleLineItem': 'بند مفرد',
            'acceptTerms': 'قبول الشروط',
            'optionA': 'الخيار أ',
            'optionB': 'الخيار ب',
            'optionC': 'الخيار جيم',
            'optionM': 'الخيار م',
            'optionN': 'الخيار ن',
            'optionO': 'الخيار O',
            'customColor': 'لون مخصص',
            'centeredTabs': 'علامات التبويب توسيط',
            'multipleTabs': 'علامات تبويب متعددة',
            'preventScrolledButtons': 'منع أزرار التمرير',
            'browse': 'تصفح',
            'formValidate': 'نموذج التحقق من الصحة',
            'code': 'الشفرة',
            'company': 'شركة',
            'price': 'السعر',
            'change': 'يتغيرون',
            'high': 'متوسط',
            'low': 'منخفض',
            'volume': 'الصوت',
            'personalDetails': 'تفاصيل شخصية',
            'occupation': 'الاحتلال',
            'companyName': 'اسم الشركة',
            'phoneNo': 'رقم الهاتف',
            'city': 'مدينة',
            'zipCode': 'الرمز البريدي',
            'updateProfile': 'تحديث الملف',
            'reject': 'رفض',
            'exportToExcel': 'تصدير إلى Excel',
            'addNewUser': 'إضافة مستخدم جديد',
            'workWeek': 'أسبوع العمل',
            'agenda': 'جدول أعمال',
            'conference': 'مؤتمر',
            'dailySales': 'المبيعات اليومية',
            'today': 'اليوم',
            'campaignPerformance': 'أداء الحملة',
            'supportRequest': 'طلب دعم',
            'usersList': 'قائمة المستخدمين',
            'lastWeek': 'الاسبوع الماضى',
            'buyMore': 'شراء المزيد',
            'trafficChannel': 'قناة المرور',
            'stockExchange': 'تداول الاسهم',
            'tweets': 'تغريدات',
            'ourLocations': 'مواقعنا',
            'sales': 'المبيعات',
            'to': 'إلى',
            'ship إلى': 'شحن إلى',
            'description': 'الوصف',
            'unitPrice': 'سعر الوحدة',
            'total': 'توتال',
            'note': 'ملاحظة',
            'chipWithAvatar': 'رقاقة مع الصورة الرمزية',
            'chipWithTextAvatar': 'رقاقة مع النص الصورة الرمزية',
            'chipWithIconAvatar': 'رقاقة مع رمز الصورة الرمزية',
            'customClickableChip': 'شريحة قابلة للنقر مخصصة',
            'outlineChip': 'مخطط تفصيلي',
            'disableChip': 'تعطيل الشريحة',
            'alertDialog': 'تنبيه الحوار',
            'animatedSlideDialogs': 'الرسوم المتحركة الشرائح المتحركة',
            'fullScreenDialogs': 'مربعات الشاشة الكاملة',
            'formDialogs': 'شكل حوار',
            'simpleDialogs': ' حوار بسيط',
            'responsiveFullScreen': 'مستجيب ملء الشاشة',
            'primary': 'الابتدائية',
            'social': 'الاجتماعية',
            'user': 'المستخدم',
            'admin': 'المسؤول',
            'permanentdrawer': 'درج دائم',
            'persistentdrawer': 'درج دائم',
            'swiches': 'و swiches',
            'horizontalLinearAlternativeLabel': 'تسمية بديلة خطية أفقية',
            'horizontalNonLinearAlternativeLabel': 'الأفقي البديل غير الخطي تسمية',
            'notifications': 'الإشعارات',
            'basicAlert': 'التنبيه الأساسي',
            'successAlert': 'تنبيه النجاح',
            'warningAlert': 'تنبيه تحذير',
            'reactAutoSuggest': 'رد السيارات اقتراح',
            'components': 'مكونات',
            'inputAdornments': 'المدخلات الزينة',
            'multiSelectList': 'قائمة تحديد متعددة',
            'contextualColoredTable': '',
            'updateYourEmailAddress': 'تحديث عنوان بريدك الإلكتروني',
            'selectADefaultAddress': 'تحديد عنوان افتراضي',
            'activity': 'آخر',
            'basicCalendar': 'التقويم الأساسي',
            'culturesCalendar': 'التقويم الثقافات',
            'dragAndDropCalendar': 'سحب إسقاط النشر',
            'quillEditor': 'محرر الريشة',
            'reactDND': 'رد Dnd',
            'dragula': 'dragula',
            'AcceptorrRejectWithin': 'قبول أو رفض في الداخل',
            'quoteOfTheDay': 'اقتبس من اليوم',
            'updated10Minago': 'تم التحديث قبل 10 دقيقة',
            'personalSchedule': 'جدول شخصي',
            'activeUsers': 'المستخدمين النشطين',
            'totalRequest': 'مجموع الطلب',
            'new': 'الجديد',
            'ShareWithFriends': 'شارك مع الاصدقاء!',
            'helpToShareText': 'ساعدنا في نشر العالم من خلال مشاركة موقع الويب الخاص بنا مع أصدقائك ومتابعيك على وسائل التواصل الاجتماعي!',
            'thisWeek': 'هذا الاسبوع',
            'howWouldYouRateUs': 'كيف تقيم لنا؟',
            'booking': 'الحجز',
            'confirmed': 'تم تأكيد',
            'monthly': 'شهريا',
            'weekly': 'أسبوعيا',
            'target': 'الهدف',
            'totalActiveUsers': 'مجموع المستخدمين النشطين',
            'deadline': 'الموعد النهائي',
            'team': 'الفريق',
            'projectManagement': 'ادارة مشروع',
            'latestPost': 'آخر وظيفة',
            'projectTaskManagement': 'إدارة مهام المشروع',
            'selectProject': 'حدد المشروع',
            'activityBoard': 'مجلس النشاط',
            'checklist': 'قائمة تدقيق',
            'baseConfig': 'التكوين الأساسي',
            'customControlBar': 'شريط التحكم المخصص',
            'withDownloadButton': 'مع زر التحميل',
            'httpLiveStreaming': 'HTTP بث مباشر',
            'keyboardShortcuts': 'اختصارات لوحة المفاتيح',
            'preview': 'معاينة',
            'croppedImage': 'صورة مقصوصة',
            'transactionList': 'قائمة المعاملات',
            'transferReport': 'نقل تقرير',
            'expenseCategory': 'فئة حساب',
            'upcomingEvents': 'الأحداث القادمة',
            'OngoingProjects': 'مشاريع جارية',
            'ProjectStatus': 'حالة المشروع',
            'LiveChatSupport': 'دعم الدردشة الحية'
        },
        'components': {
            'buyNow': 'اشتري الآن',
            'alreadyHavingAccountSignIn': 'بالفعل لديك حساب تسجيل الدخول',
            'enterYourPassword': 'ادخل رقمك السري',
            'unlock': 'فتح',
            'enterPasswords': 'أدخل كلمات المرور',
            'resetPassword': 'إعادة ضبط كلمة المرور',
            'pageNotfound': 'الصفحة غير موجودة',
            'goToHomePage': 'الذهاب إلى الصفحة الرئيسية',
            'sorryServerGoesWrong': 'آسف خادم يذهب خاطئة',
            'persistentDrawer': 'درج دائم',
            'back': 'الى الخلف',
            'next': 'التالى',
            'completeStep': 'خطوة كاملة',
            'withHtml': 'مع هتمل',
            'prompt': 'مستعجل',
            'withDescription': 'مع الوصف',
            'success': 'نجاح',
            'passwordPrompt': 'كلمة المرور موجه',
            'warning': 'تحذير',
            'customIcon': 'أيقونة مخصصة',
            'customStyle': 'نمط مخصص',
            'basic': 'الأساسية',
            'submit': 'خضع',
            'compose': 'مؤلف موسيقى',
            'sendMessage': 'ارسل رسالة',
            'addNewTasks': 'إضافة مهام جديدة',
            'addToCart': 'أضف إلى السلة',
            'payNow': 'ادفع الآن',
            'print': 'طباعة',
            'cart': 'عربة التسوق',
            'viewCart': 'عرض العربة',
            'checkout': 'الدفع',
            'summary': 'ملخص',
            'yesterday': 'بالأمس',
            'last7Days': 'آخر 7 أيام',
            'last1Month': 'آخر 1 شهر',
            'last6Month': 'آخر 6 أشهر',
            'spaceUsed': 'الفضاء المستخدمة',
            'followers': 'أتباع',
            'trending': 'الإمالة',
            'paid': 'مدفوعة',
            'refunded': 'المردودة',
            'done': 'تم',
            'pending': 'معلق',
            'cancelled': 'ألغي',
            'approve': 'الموافقة',
            'week': 'أسبوع',
            'month': 'شهر',
            'year': 'السنة',
            'today': 'اليوم',
            'popularity': 'الشعبية',
            'email': 'البريد الإلكتروني',
            'drafts': '',
            'sent': 'المرسلة',
            'trash': 'المهملات',
            'all': 'الكل',
            'do': 'هل',
            'title': 'العنوان',
            'projectName': 'اسم المشروع',
            'companyName': 'اسم الشركة',
            'openAlert': 'فتح تنبيه',
            'slideInAlertDialog': 'الانزلاق في حوارات التنبيه',
            'openFullScreenDialog': 'فتح مربعات شاشة كاملة',
            'basicChip': 'رقاقة الأساسية',
            'clickableChip': '',
            'left': 'اليسار',
            'right': 'الحق',
            'expansionPanel1': 'لوحة التوسعة 1',
            'expansionPanel2': 'رقاقة قابلة للنقر',
            'generalSetting': 'الإعداد العام',
            'advancedSettings': 'إعدادات متقدمة',
            'firstName': 'الاسم الأول',
            'lastName': 'اسم العائلة',
            'occupation': 'العمل',
            'phoneNo': 'رقم الهاتف',
            'address': 'عنوان',
            'city': 'المدينة',
            'state': 'الدولة',
            'zip Code': 'الرمز البريدي',
            'emailPrefrences': 'تفضيلات البريد الإلكتروني',
            'myProfile': 'ملفي',
            'product': 'المنتج',
            'quantity': 'كمية',
            'totalPrice': 'السعر الكلي',
            'removeProduct': 'إزالة المنتج',
            'mobileNumber': 'رقم الهاتف المحمول',
            'address2Optional': 'العنوان 2 (اختياري)',
            'country': 'بلد',
            'zip': 'الرمز البريدي',
            'saveContinue': 'حفظ ومتابعة',
            'placeOrder': 'مكان الامر',
            'payment': 'دفع',
            'billingAddress': 'عنوان وصول الفواتير',
            'ShippingAddressText': 'عنوان الشحن هو نفسه عنوان الفواتير.',
            'CartEmptyText': 'سلة التسوق الخاصة بك فارغة!',
            'NoItemFound': 'لا يوجد بند',
            'goToShop': 'الذهاب للتسوق',
            'cardNumber': 'رقم البطاقة',
            'expiryDate': 'تاريخ الانتهاء',
            'cvv': 'CVV',
            'nameOnCard': 'الاسم على البطاقة',
            'confirmPayment': 'تأكيد الدفع'
        },
        'compenets': {
            'choose': 'أختر',
            'username': 'اسم المستخدم',
            'passwords': 'كلمات السر',
            'signIn': 'تسجيل الدخول',
            'dontHaveAccountSignUp': 'لا تملك حساب تسجيل الدخول',
            'enterUserName': 'ادخل اسم المستخدم',
            'enterEmailAddress': 'أدخل عنوان البريد الالكتروني',
            'confirmPasswords': 'تأكيد كلمات المرور'
        },
        'themeOptions': {
            'sidebarOverlay': 'تراكب الشريط الجانبي',
            'sidebarBackgroundImages': 'صور خلفية الشريط الجانبي',
            'sidebarImage': 'صورة الشريط الجانبي',
            'miniSidebar': 'ميني الشريط الجانبي',
            'boxLayout': 'تخطيط مربع',
            'rtlLayout': 'تخطيط Rtl',
            'darkMode': 'وضع الظلام',
            'appSettings': 'إعدادات التطبيقات',
            'sidebarLight': 'ضوء',
            'sidebarDark': 'داكن',
            'themeColor': 'لون الموضوع'
        },
        'button': {
            'cancel': 'إلغاء',
            'add': 'إضافة',
            'update': 'تحديث',
            'reply': 'الرد',
            'delete': 'حذف',
            'yes': 'نعم فعلا',
            'viewAll': 'عرض الكل',
            'like': 'مثل',
            'assignNow': 'تعيين الآن',
            'seeInsights': 'اطلع على الإحصاءات',
            'acceptTerms': 'قبول الشروط',
            'reject': 'رفض',
            'addNew': 'اضف جديد',
            'goToCampaign': 'الذهاب الى الحملة',
            'viewProfile': 'عرض الملف الشخصي',
            'sendMessage': 'إرسال رسالة',
            'saveNow': 'احفظ الان',
            'pen': 'القلم',
            'search': 'بحث',
            'downloadPdfReport': 'تنزيل تقرير PDF',
            'primary': 'الابتدائية',
            'secondary': 'الثانوية',
            'danger': 'خطر',
            'info': 'معلومات',
            'success': 'النجاح',
            'warning': 'تحذير',
            'link': 'لينك',
            'smallButton': 'زر صغير',
            'largeButton': 'زر كبير',
            'blockLevelButton': 'زر مستوى الكتلة',
            'primaryButton': 'الزر الرئيسي',
            'button': 'زر',
            'save': 'حفظ',
            'openMenu': 'فتح القائمة',
            'openWithFadeTransition': 'مفتوحة مع التحول تتلاشى',
            'openPopover': 'فتح بوبوفر',
            'accept': 'قبول',
            'click': 'انقر فوق',
            'complete': 'كاملة',
            'back': 'Back',
            'next': 'التالي',
            'completeStep': 'إكمال الخطوة',
            'error': 'خطأ',
            'writeNewMessage': 'كتابة رسالة جديدة',
            'saveChanges': 'حفظ التغييرات',
            'addNewUser': 'إضافة مستخدم جديد',
            'more': 'المزيد',
            'useDefaultImage': 'استخدام الصورة الافتراضية',
            'cropImage': 'قص الصوره'
        },
        'hint': {
            'whatAreYouLookingFor': 'ما الذي تبحث عنه',
            'searchMailList': 'البحث في قائمة البريد'
        },
        'module': {
            'inbox': 'صندوق الوارد',
            'drafts': '',
            'sent': 'المرسلة',
            'trash': 'المهملات',
            'spam': 'بريد مؤذي',
            'frontend': 'نهاية المقدمة',
            'backend': 'الخلفية',
            'api': 'المعهد',
            'issue': 'القضية'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {},
        'component': {
            'social Connection': 'التواصل الاجتماعي'
        }
    }
};